import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsHex_3(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isHex_3 = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;

    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    if (index < 0) return false;

    const protocol = Iv_list.iv_protocol?.[index] || "";
    return String(protocol).toLowerCase() === "hex_3";
  }, [Iv_list, SelInverter]);

  return isHex_3;
}
